import { arrayUnion } from 'firebase/firestore';
import { userService } from '@/services';

export const PWA_PROMPT_READY_EVENT = 'pulp-pwa-install-prompt-ready';
export const PWA_INSTALLED_KEY = 'pulp_pwa_installed';
export const PWA_PENDING_INSTALL_KEY = 'pulp_pending_pwa_install';
export const PWA_INSTALLED_EVENT = 'pulp-pwa-installed';

export interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
  prompt(): void;
}

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
    [PWA_PROMPT_READY_EVENT]: CustomEvent;
    [PWA_INSTALLED_EVENT]: CustomEvent;
  }
  interface Window {
    __pulpPwaDeferredPrompt?: BeforeInstallPromptEvent | null;
  }
  interface Navigator {
    standalone?: boolean;
  }
}

export function recordPwaInstall(uid: string, timestamp: string) {
  void userService.updateProfile(uid, { pwaInstalledAt: arrayUnion(timestamp) });
}
